import React from 'react';
import type { View } from '../types';

const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
const CrownIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 18v-2a4 4 0 014-4h6a4 4 0 014 4v2M5 18a2 2 0 00-2 2h18a2 2 0 00-2-2M12 12a4 4 0 110-8 4 4 0 010 8z" /></svg>;

interface UpgradeModalProps {
    onNavigate: (view: View) => void;
    onClose: () => void;
}


const UpgradeModal: React.FC<UpgradeModalProps> = ({ onNavigate, onClose }) => {

  const handleGoToPricing = () => {
      onNavigate('pricing');
      onClose();
  }

  return (
    <div onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-50 modal-enter" role="dialog" aria-modal="true">
      <div onClick={(e) => e.stopPropagation()} className="bg-gradient-to-br from-[#1a2a47] to-[#15243E] rounded-2xl border border-blue-900/50 w-full max-w-lg text-gray-300 p-8 shadow-2xl relative text-center">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-white"><CloseIcon /></button>
        <div className="flex justify-center mb-4"><CrownIcon /></div>
        <h2 className="text-3xl font-bold text-white">Upgrade to Dr.Rx Plus or Pro</h2>
        <p className="text-gray-400 mt-4">You've reached your usage limit or tried to access a premium feature. Upgrade your plan to unlock unlimited AI interactions, advanced clinical tools, and the full study library.</p>
        <button onClick={handleGoToPricing} className="w-full mt-8 bg-gradient-to-br from-yellow-400 to-yellow-500 text-gray-900 font-bold py-3 rounded-lg transition-all hover:shadow-lg hover:shadow-yellow-500/20 hover:scale-[1.02]">
            View Plans & Upgrade
        </button>
      </div>
    </div>
  );
};

export default UpgradeModal;